import React from 'react';
import { useTranslation } from 'react-i18next';
import { InputSuffix } from '@progress/kendo-react-inputs';
import { Icon } from '@components-clean/core/icons/icon';

interface ValidationIconSuffixProps {
    validationMessage?: string;
    padding?: 'small' | 'regular' | 'none';
    tooltipPosition?: 'right' | 'auto' | 'left';
    maxWidth?: number;
}

const ValidationIconSuffix = ({
    validationMessage,
    padding = 'regular',
    tooltipPosition = 'right',
    maxWidth,
}: ValidationIconSuffixProps) => {
    const { t } = useTranslation();

    return (
        <InputSuffix>
            <Icon
                dataTestId="validation-suffix-icon"
                icon={['far', 'exclamation-circle']}
                className="k-color-error k-cursor-help"
                title={validationMessage ?? t('validationIconSuffixDefaultMessage')}
                tooltipPosition={tooltipPosition}
                isError
                isSuffix
                padding={padding}
                maxWidth={maxWidth}
            />
        </InputSuffix>
    );
};

export default ValidationIconSuffix;
